import { Component, h } from "preact";

export interface ISelectBoxProps {
  items: string[];
  disabled?: boolean;
}

export interface ISelectBoxState {
  tags: string[];
}

export default class SelectBox extends Component<
  ISelectBoxProps & ISelectBoxState,
  ISelectBoxState
> {
  private selectElt?: HTMLSelectElement;
  private tagElt?: HTMLSelectElement;

  public render() {
    return (
      <div class="container" style="padding-left: 0px;">
        <div class="row">
          <div class="col-md-4">
            <div class="input-group">
              <div
                class="multi-select"
                ref={by => (this.tagElt = by as HTMLSelectElement)}
              >
                {this.renderTags()}
              </div>
              <div class="input-group-btn align-top">
                <button
                  type="button"
                  style="height:32px; display: inline-block;"
                  class="btn btn-default btn-icon align-top"
                  disabled={this.props.disabled}
                  onClick={() => {
                    if (
                      this.selectElt &&
                      this.selectElt.style &&
                      this.selectElt.style.display
                    ) {
                      this.selectElt.style.display =
                        this.selectElt.style.display === "none"
                          ? "block"
                          : "none";
                    }
                  }}
                >
                  <i class="fa fa-search" />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <select
              style="display: none"
              ref={by => (this.selectElt = by as HTMLSelectElement)}
              class="form-control select-from"
              disabled={this.props.disabled}
              onChange={(x: any) =>
                this.addInput((x.target as HTMLInputElement).value)
              }
              multiple={true}
            >
              <option value="-1">Select</option>
              {this.props.items.map(item => (
                <option value={item}>{item}</option>
              ))}
            </select>
          </div>
        </div>
      </div>
    );
  }

  private onRemove(item: string): void {
    if (item !== "-1") {
      const index = this.props.tags.indexOf(item);
      if (index >= 0) {
        this.props.tags.splice(index, 1);
        this.setState({ tags: [...this.props.tags] });
      }
    }
  }

  private addInput(item: string): void {
    if (item !== "-1" && this.props.tags.indexOf(item) < 0) {
      this.props.tags.push(item);
      this.setState({ tags: [...this.props.tags] });
    }
  }

  private renderTags() {
    return (
      <ul>
        {this.props.tags.map(item => (
          <li>
            <a class="label">
              {item}
              <i onClick={() => this.onRemove(item)} class="fa fa-close" />
            </a>
          </li>
        ))}
        <li>&nbsp;</li>
      </ul>
    );
  }
}
